import {SignedOutSessionStorage, UserProfileLocalStorage} from "./Constants";
import secureStorage from "react-secure-storage";

const secureLocalStorage =
  (secureStorage as unknown as { default?: typeof secureStorage }).default ?? secureStorage;

export class storageMng {
  static setItem(key:string,value:string ){ 
      secureLocalStorage.setItem(key, value);
  } 
  static getItem(key:string):string | null{ 
    const value =secureLocalStorage.getItem(key);
    return value?value.toString():null;
  }
  public static remove(key:string){ 
    secureLocalStorage.removeItem(key);
  }

  public static removeUserProfile(){
    this.remove(UserProfileLocalStorage);
  }

  public static storSignedOut(isSignedOut:string ){
    this.setItem(SignedOutSessionStorage, isSignedOut);
  }
  public static getSignedOut():string|null{
    return this.getItem(SignedOutSessionStorage);
  }
  public static removeSignedOut(){
    this.remove(SignedOutSessionStorage);
  }

  public static clearStorage(){ 
    this.removeUserProfile();
    this.removeSignedOut();
  }
}